import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Orders.css'; // Убедитесь, что создали соответствующий CSS файл
import axios from 'axios';
import Sidebar from './sidebar';
import { format } from 'date-fns';

const Orders = () => {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [statusFilters, setStatusFilters] = useState([]);
  const [paymentFilters, setPaymentFilters] = useState([]);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}v1/orders`, {
      headers: {
        'x-api-key': '12345xxa'
      }
    })
    .then((res) => {
      setOrders(res.data);
    })
    .catch((error) => {
      console.error('Ошибка при получении данных о заказах:', error);
    });
  }, []);

  const handleRowClick = (orderId) => {
    setSelectedOrderId(orderId);
    navigate(`/orders/${orderId}`);
  };

  const renderRow = (order) => {
    const formattedDate = format(new Date(order.created_at), 'dd/MM/yyyy HH:mm');
    const formattedDeliveryDate = format(new Date(order.delivery_date), 'dd/MM/yyyy');
    const rowClassName = order.id === selectedOrderId ? 'selected-row' : '';

    return (
      <tr key={order.id} onClick={() => handleRowClick(order.id)} className={rowClassName}>
        <td>{formattedDate}</td>
        <td>{order.client_name}</td>
        <td>{order.order_number}</td>
        <td>{order.delivery_address}</td>
        <td>{formattedDeliveryDate}</td>
        <td>{order.status_name}</td>
        <td>{order.payment_status}</td>
        <td>{order.total_amount}</td>
      </tr>
    );
  };

  const handleStatusFilterChange = (status) => {
    setStatusFilters((prevFilters) => 
      prevFilters.includes(status) 
      ? prevFilters.filter((s) => s !== status) 
      : [...prevFilters, status]
    );
  };

  const handlePaymentFilterChange = (paymentStatus) => {
    setPaymentFilters((prevFilters) => 
      prevFilters.includes(paymentStatus) 
      ? prevFilters.filter((p) => p !== paymentStatus) 
      : [...prevFilters, paymentStatus]
    );
  };

  const handleResetFilters = () => {
    setStatusFilters([]);
    setPaymentFilters([]);
    setSearch('');
    setStartDate('');
    setEndDate('');
  };

  const filteredOrders = orders.filter((order) => {
    const matchesStatusFilter = !statusFilters.length || statusFilters.includes(order.status_name);
    const matchesPaymentFilter = !paymentFilters.length || paymentFilters.includes(order.payment_status);
    const matchesSearch = !search || 
      (order.client_name && order.client_name.toLowerCase().includes(search.toLowerCase())) || 
      (order.delivery_address && order.delivery_address.toLowerCase().includes(search.toLowerCase())) || 
      (order.order_number && order.order_number.toString().toLowerCase().includes(search.toLowerCase()));

    const orderDate = new Date(order.created_at);
    const matchesDate = (!startDate || new Date(startDate) <= orderDate) && (!endDate || orderDate <= new Date(endDate));

    return matchesStatusFilter && matchesPaymentFilter && matchesSearch && matchesDate;
  });

  return (
    <div className="main-container-crm">
      <Sidebar />
      <div className="orders-content">
        <h1 className="orders-list-zagolovok">Заказы</h1>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Поиск по названию клиента, адресу доставки или номеру заказа"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <input
            type="date"
            placeholder="Начальная дата"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            placeholder="Конечная дата"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <div className="filters">
          <div className="status-filters">
            <button 
              className={`filter-button ${statusFilters.includes('Ожидает подтверждения') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('Ожидает подтверждения')}
            >
              Ожидает подтверждения
            </button>
            <button 
              className={`filter-button ${statusFilters.includes('В пути') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('В пути')}
            >
              В пути
            </button>
            <button 
              className={`filter-button ${statusFilters.includes('Отменён') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('Отменён')}
            >
              Отменён
            </button>
            <button 
              className={`filter-button ${statusFilters.includes('Доставлен') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('Доставлен')}
            >
              Доставлен
            </button>
            <button 
              className={`filter-button ${statusFilters.includes('Подтверждён') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('Подтверждён')}
            >
              Подтверждён
            </button>
            <button 
              className={`filter-button ${statusFilters.includes('Комплектуется') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('Комплектуется')}
            >
              Комплектуется
            </button>
            <button 
              className={`filter-button ${statusFilters.includes('Готов к отправке') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('Готов к отправке')}
            >
              Готов к отправке
            </button>
            <button 
              className={`filter-button ${statusFilters.includes('Возврат') ? 'active' : ''}`} 
              onClick={() => handleStatusFilterChange('Возврат')}
            >
              Возврат
            </button>
            <button 
              className={`filter-button ${paymentFilters.includes('Оплачено') ? 'active' : ''}`} 
              onClick={() => handlePaymentFilterChange('Оплачено')}
            >
              Оплачено
            </button>
            <button 
              className={`filter-button ${paymentFilters.includes('Ожидает оплаты') ? 'active' : ''}`} 
              onClick={() => handlePaymentFilterChange('Ожидает оплаты')}
            >
              Ожидает оплаты
            </button>
          </div>
          
          <div className="reset-filters">
            <button className="filter-button" onClick={handleResetFilters}>Сбросить фильтры</button>
          </div>
        </div>
        <table className="orders-table">
          <thead>
            <tr>
              <th>Дата</th>
              <th>Клиент</th>
              <th>Заказ</th>
              <th>Адрес</th>
              <th>Дата доставки</th>
              <th>Статус заказа</th>
              <th>Оплата</th>
              <th>Сумма</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.slice(0, 8).map(renderRow)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Orders;
